export default __webpack_public_path__ + "static/1-0f78fd96f4dfe9e28ead100f5ead53e3.gif";